import React, { type ReactNode } from 'react';

import { RuntimeContext, type RuntimeConfig } from './Runtime.context';

type RuntimeProviderProps = {
    children: ReactNode;
    runtimeConfig: RuntimeConfig;
};

const RuntimeProvider = ({ children, runtimeConfig }: RuntimeProviderProps) => {
    return <RuntimeContext.Provider value={runtimeConfig}>{children}</RuntimeContext.Provider>;
};

export default RuntimeProvider;
